<template>
  <div class="page-template add-page deliver-add order-add-page">
    <div class="page-title">{{ title }}
    </div>
    <div class="btn-box">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
      <el-button v-if="this.$route.query.auditStatus === '20'" :disabled="true" @click="submitAuth" type="primary"
                 plain>保存
      </el-button>
      <el-button v-else @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button @click="examineAndVerify" type="primary" plain :disabled="formModel.auditStatus === null">审核
      </el-button>
      <el-button @click="complexFunc" type="primary" plain
      >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <list-operation-form v-show="complexShow" ref="listOperationForm" :formOptions="listFormOptions"
                         @valueChange="listFormValueChange"></list-operation-form>
    <div class="search-goods-box">
      <el-input id="goodsText"
                placeholder="条码/自编码/助记码"
                v-model="goodsTxt"
                class="search-goods-input"
                @change="search"
      >
        <template slot="prepend">
          <span>综合搜索</span>
        </template>
        <template slot="append">
          <!--<div class="el-icon-search more-btn" @click="search"></div>-->
          <div class="el-icon-search more-btn"></div>
        </template>
      </el-input>
      <el-button @click="checkGoods" type="primary" plain class="select-good">选择商品</el-button>
      <!--<el-button @click="downloadTemplate" type="primary" plain>下载模板</el-button>-->
      <!--<el-button @click="importData" type="primary" plain>导入商品</el-button>-->
      <el-button @click="openImport" type="primary" plain>导入商品</el-button>
    </div>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
    <el-dialog title="商品列表" :visible.sync="listShow" width="1200px" height="800" :close-on-click-modal="false">
      <good-list
        v-if="listShow"
        @rowCheck="rowCheck"
        :isSelect="goodListSelect"
        :otherParam="otherParam"
        :tableOptions="tableOptions"
        @selectSubmit="rowsSelectSubmit"
        :selectUrl="selectUrl"
        :listTableData="listTableData"
      ></good-list>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="importShow" custom-class="importDialog" :close-on-click-modal="false">
      <import-template v-if="importShow" ref="importTemplate" :importShow="importShow"
                       @importFile="importData" @downTemplate="downloadTemplate"></import-template>
    </el-dialog>
  </div>
</template>
<script>
  // 商品列表组件
  import goodList from '@/components/business/goodList';
  // 添加要货单组件
  import listOperationNew from "@/components/template/listOperationNew";
  // 要货单搜索组件
  import listOperationForm from '@/components/template/listOperationForm';

  import api from '@/config/api';
  import userPower from '@/mixin/userPower'
  // 导入模版组件
  import importTemplate from '@/components/business/importTemplate';

  export default {
    mixins: [userPower],
    components: {
      listOperationNew,
      goodList,
      listOperationForm,
      importTemplate
    },
    data() {
      return {
        importShow: false,
        isCheck: false,
        complexShow: true,
        goodsTxt: "",
        listTableData: [], // 用于传给选择商品组件，判断是否已被选择
        goodListSelect: false,
        title: '',
        listShow: false,
        goodList: [],
        dialogShow: false,
        formModel: {
          auditStatus: null
        },
        selectUrl: {url: api.warehouse.warehouseGoods},
        otherParam: {statusList: [10, 20, 30], isOpenCombination: 2, noSonCombinationGoods: true},
        isSelectStore: true,
        isSelectDeliverStoreId: true,
        // 添加头部字段
        listFormOptions: {
          statusOption: {
            prop: 'auditStatus',
            statusImg: {
              20: '/static/checked.png',
              10: '/static/un-check.png'
            },
            right: '100px',
            top: '0'
          },
          labelWidth: '130px',
          columns:
            [{
              prop: 'id',
              hidden: true
            },
              {
                label: '业务单号',
                type: 'input',
                prop: 'orderNo',
                span: 12,
                disabled: true
              }, {
              label: '要货门店',
              type: 'storeInputDialog',
              prop: 'requireStoreId',
              // data: [],
              span: 12,
              // isHasAll: true,
              // url: api.system.seStore,
              // disabled: this.$utils.getSysUser().storeId == null ? false : true,
              // defaultValue: this.$utils.getSysUser().storeId,
              // change: this.getWarehouse,
              rule: [
                {required: true, message: '请选择要货门店', trigger: 'change'}
              ]
            },
              // {
              //   label: '调拨级别',
              //   type: 'select',
              //   prop: 'relateType',
              //   data: this.$utils.getCacheStatus('dnRequireOrder.relateType'),
              //   change: this.selectLevel,
              //   span: 12,
              // },
              {
                label: '发货门店',
                type: 'storeInputDialog',
                prop: 'deliverStoreId',
                data: [],
                span: 12,
                // isHasAll: true,
                // change: this.storeChange,
                // url: api.system.seStore
              },
              //   {
              //   label: '有效日期',
              //   prop: 'effectiveDttm',
              //   type: 'dateTimePicker',
              //   dateType: 'datetime',
              //   span: 12,
              //   rule: [
              //     {required: true, message: '请选择有效日期', trigger: 'change'}
              //   ]
              // },
              {
                label: '备注',
                type: 'input',
                maxLength: 16,
                prop: 'remarks',
                span: 12
              }]
        },
        // 添加表格字段
        listColumns: {
          disabled: false,
          // 是否显示索引
          indexShow: true,
          summaryColumns: ['blitemNum', 'subtotalAmount'],
          columns: [
            {label: '操作', type: 'operation', width: 100, prop: 'operation'},
            {label: '序号', type: 'index', width: 60, prop: 'idx'},
            // {
            //   label: '选择商品',
            //   prop: 'selectGoods',
            //   type: 'more',
            //   width: '90'
            // },
            {
              label: '条码',
              prop: 'barCode',
              // type: 'input',
              width: '150',
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '100'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '80'
            },
            {
              label: '类别',
              prop: 'goodsCategoryName',
              width: '100'
            },
            {
              label: '品牌',
              prop: 'goodsBrandName',
              width: '100'
            },
            {
              label: '配送价',
              prop: 'deliveryPrice',
              width: '100',
              type: 'inputNumber',
              change: this.numChange,
              max: 99999.99,
              precision: 2
            },
            {
              label: '数量',
              width: '100',
              prop: 'blitemNum',
              type: 'inputNumber',
              max: 9999.999,
              change: this.blitemNumNumChange,
              precision: 3
            },
            {
              label: '小计金额',
              prop: 'subtotalAmount',
              width: '100'
            },
            // {
            //   label: '当前门店库存',
            //   prop: 'inventoryNum',
            //   width: '120'
            // },
            {
              label: '零售价',
              prop: 'retailPrice',
              width: '80'
            },
            {
              label: '备注',
              prop: 'remarks',
              type: 'input',
              maxLength: 16,
              width: '150'
            },

          ],
          url: api.warehouse.blitem
        },
        // 表格信息配置
        tableOptions: {
          // 是否显示索引
          indexShow: true,
          // 自定义列索引
          indexMethod: (index) => {
            return index + 1;
          },
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '200',
              align: 'center'
            },
            {
              label: '品名',
              prop: 'goodsName',
              width: '100',
              align: 'center'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '100',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '200',
              align: 'center'
            },
            {
              label: '配送价',
              prop: 'deliveryPrice',
              width: '150',
              align: 'center'
            }
          ],
          param: this.otherParam,
          url: api.archives.goodsInfoIncludeSpecs
        },
        checkIndex: ''
      }
    },
    created() {
      this.title = document.title + (this.$route.query.id ? '-编辑' : '-新增');
      if (this.$route.query.id) {
        this.getDetail();
      }
      this.setDnStoreId(this.listFormOptions.columns);
      let user = this.$utils.getSysUser();
      if (user.storeId) {
        this.isSelectStore = false;
      }
    },
    methods: {
      //点击 高级搜索显示
      complexFunc() {
        if (!this.isCheck) {
          this.complexShow = !this.complexShow;
        }
      },
      listFormValueChange(value, column) {
        if (column.prop == "requireStoreId") {
          this.$refs.listOperationForm.formModel.requireStoreId = value.id;
          this.listFormOptions.columns.filter(
            item => item.prop === "requireStoreId"
          )[0].params = {requireStoreId: value.id};
        }
        if (column.prop == "deliverStoreId") {
          this.$refs.listOperationForm.formModel.deliverStoreId = value.id;
          this.listFormOptions.columns.filter(
            item => item.prop === "deliverStoreId"
          )[0].params = {deliverStoreId: value.id};
        }
        if (column.prop == "requireStoreId") {
          this.isSelectStore = false;
          this.otherParam.requireStoreId = value.id;
        } else if (column.prop == "deliverStoreId") {
          this.otherParam.deliverStoreId = value.id;
          this.otherParam.storeId = value.id;
          this.isSelectDeliverStoreId = false;
        }
      },
      search() {
        if (this.goodsTxt === '' || this.goodsTxt === null) return;
        this.otherParam.otherName = this.goodsTxt;
        if (this.isSelectStore) {
          this.goodsTxt = '';
          this.$confirm('请选择要货门店！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
        } else {
          if (this.isSelectDeliverStoreId) {
            this.goodsTxt = '';
            this.$confirm('请选择发货门店！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            });
          } else {
            this.isCheck = true;
            this.$axios
              .fetchPost(api.warehouse.warehouseGoods + "/list", this.otherParam)
              .then(res => {
                if (res.code === 200) {
                  if (res.data.length > 0) {
                    let tableData = res.data;
                    if (tableData.length === 1) {
                      let row = tableData[0];
                      let tableList = this.$refs["listOperation"].getTabelData();
                      let flag = true;
                      if (tableList.length > 0) {
                        tableList.forEach(item => {
                          if (flag) {
                            if (item.barCode === row.barCode) flag = false;
                          }
                        });
                      }
                      if (!flag) {
                        this.$message.warning("[名称:" + row.goodsName + ",条码:" + row.barCode + "],已存在！！！");
                        return;
                      }
                      row.subtotalAmount = 0.00.toFixed(2);
                      row.blitemNum = 0.00.toFixed(3);
                      row.remarks = null;
                      // this.$refs["listOperation"].addMoreRow(row, tableList.length);
                      this.$refs["listOperation"].setColumnData(row, tableList.length);
                      this.currentTableList = this.$refs["listOperation"].getTabelData();
                      this.$message.success("商品添加成功");
                    } else {
                      this.checkGoods();
                    }
                  } else {
                    this.$message.warning("[条码:" + this.goodsTxt + "],商品不存在！！！");
                  }
                } else {
                  this.$message({type: "error", message: res.msg});
                }
              })
              .catch(err => {
              }).finally(() => {
              this.clearQueryParam();
              this.isCheck = false;
            });
          }
        }
      },
      clearQueryParam() {
        this.goodsTxt = '';
        this.otherParam.otherName = '';
      },
      // 编辑回显数据
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.delivery.requisitionDetails + '?id=' + this.$route.query.id, {})
          .then(data => {
            this.loading = false;
            if (data.code === 200) {
              this.$nextTick(() => {
                // 为头部表单赋值
                this.$refs.listOperationForm.formModel = data.data;
                this.formModel.auditStatus = data.data.auditStatus;
                this.listFormOptions.columns.filter(item => item.prop === 'requireStoreId')[0].disabled = true;
                this.listFormOptions.columns.filter(item => item.prop === 'deliverStoreId')[0].disabled = true;
                // 处理字段值与配置的表格值不一致的地方
                // 此处为示例，其他需要处理的值请各自根据业务处理
                data.data.goodsMapMVOList.map(item => {
                  item.id = item.goodsId;
                  item.name = item.goodsName;
                  item.barCode = item.goodsBarCode;
                  item.specs = item.goodsSpecs;
                  item.unitName = item.goodsUnitName;
                  item.blitemNum = item.goodsNum;
                  item.inventoryNum = item.goodsInventoryNum;
                });
                this.isSelectDeliverStoreId = false;
                this.isSelectStore = false;
                // 为表格赋值
                // this.selectLevel({relateType: data.data.relateType});
                this.$refs['listOperation'].addMoreRow(data.data.goodsMapMVOList, 0);
                this.currentTableList = this.$refs['listOperation'].getTabelData();
              });
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          })
          .catch(err => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          });
      },

      // 通过数量计算小计金额
      numChange(row, index) {
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.deliveryPrice === '' || row.deliveryPrice == null) {
          row.deliveryPrice = rowData.deliveryPrice.toString();
          return;
        }
        if (row.subtotalAmount) {
          row.subtotalAmount = parseFloat(row.deliveryPrice * row.blitemNum).toFixed(2);
        }
        this.$refs['listOperation'].setCountData(row, index);
      },
      blitemNumNumChange(row, index) {
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.blitemNum === '' || row.blitemNum == null) {
          row.blitemNum = rowData.blitemNum.toString();
          return;
        }
        if (row.subtotalAmount) {
          row.subtotalAmount = parseFloat(row.deliveryPrice * row.blitemNum).toFixed(2);
        }
        this.$refs['listOperation'].setCountData(row, index);
      },

      // 选择某行数据
      rowCheck(row) {
        this.listShow = false;
        row.subtotalAmount = 0.00.toFixed(2);
        row.blitemNum = 0.00.toFixed(3);
        this.$refs['listOperation'].setColumnData(row, this.checkIndex);
        this.currentTableList = this.$refs['listOperation'].getTabelData();
      },

      validePirce(val) {
        const priceArray = ['buyPrice', 'deliveryPrice', 'lowestPrice', 'plusVipPrice', 'retailPrice', 'tradePrice', 'vipPrice'];
        if (priceArray.includes(val)) {
          return true
        } else {
          return false
        }
      },
      valideMount(val) {
        const mountArray = ['blitemNum'];
        if (mountArray.includes(val)) {
          return true
        } else {
          return false
        }
      },

      // 提交数据
      submitAuth() {
        if (!this.isCheck) {
          let tableList = this.$refs['listOperation'].getTabelData();
          let orderNumber = 1;
          if (tableList.length === 0) {
            this.$message.warning("表格数据为空,无法保存");
            return false;
          }
          tableList.map(item => {
            item.orderNumber = orderNumber++;
            item.goodsNum = item.blitemNum;
          });
          let totalParam = this.$refs['listOperation'].getSumData();
          totalParam.billAmount = totalParam.subtotalAmount;
          let headParam = this.$refs.listOperationForm.getFormModel();
          if (headParam.requireStoreId === headParam.deliverStoreId) {
            this.$message.warning("发货门店和要货门店不能相同");
            return;
          }
          headParam.auditStatus = this.formModel.auditStatus;
          let searchParam = {
            ...{goodsMapMVOList: tableList}, ...totalParam, ...headParam
          };
          let axiosUrl = '';
          if (headParam.id) {
            searchParam.operateFlag = 'update';
            axiosUrl = '/api/eros/dn/dnRequireOrder/updaterequireorder';
          } else {
            axiosUrl = '/api/eros/dn/dnRequireOrder/insertrequireorder';
          }
          let priceLength = 0;
          let length = 0;
          tableList.map(table => {
            if (table.goodsNum === 0) {
              length = length + 1;
            }
            if (table.deliveryPrice === 0) {
              priceLength = priceLength + 1;
            }
          });
          let priceFlag = false
          let mountFlag = false
          tableList.map(item => {
            for (let key in item) {
              if (this.validePirce(key)) {
                if (item[key] > 99999.99) {
                  priceFlag = true
                }
              }
              if (this.valideMount(key)) {
                if (item[key] > 9999.999) {
                  mountFlag = true
                }
              }
            }
          })
          if (mountFlag) return this.$message.warning('数量相关不能超过9999.999')
          if (priceFlag) return this.$message.warning('价格不能超过99999.99')
          if (length > 0) {
            this.$message({message: '存在数量为0的商品，不能进行保存/审核！', type: 'warning'});
          } else {
            if (priceLength > 0) {
              this.$message({message: '存在配送价为0的商品，不能进行保存/审核！', type: 'warning'});
            } else {
              this.saveData(axiosUrl, searchParam);
            }
          }
        }
      },
      // 保存
      saveData(axiosUrl, searchParam) {
        this.$confirm('是否保存，请确认数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '提交中，请稍候...',
            background: 'rgba(225, 225, 225, 0.8)'
          });
          this.$axios
            .fetchPost(axiosUrl, searchParam)
            .then(data => {
              this.loading = false;
              if (data.code === 200) {
                this.dialogShow = false;
                this.$refs.listOperationForm.formModel = data.data;
                this.formModel.auditStatus = data.data.auditStatus;
                this.$notify({
                  type: "success",
                  title: '保存操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: '保存成功！', type: 'success'});
              } else {
                this.$message({message: data.msg, type: 'error'});
              }
            })
            .catch(err => {
              console.log(err);
              this.$message({message: '请求失败！', type: 'error'});
              this.loading = false;
            }).finally(() => {
            loading.close()
          })
        });
      },
      // 返回按钮事件
      beBack() {
        if (!this.isCheck) {
          this.$router.go(-1);
        }
      },

      // 刷新按钮事件
      refresh() {
        if (!this.isCheck) {
          this.$router.go(0);
        }
      },

      // 选择商品安装事件
      checkGoods() {
        if (this.isSelectStore) {
          this.$confirm('请选择要货门店！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          });
        } else {
          if (this.isSelectDeliverStoreId) {
            this.$confirm('请选择发货门店！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            });
          } else {
            let data = this.$refs.listOperationForm.formModel;
            if (data.requireStoreId === data.deliverStoreId) {
              this.$message.warning("发货门店和要货门店不能相同");
              return;
            }
            this.listShow = true;
            this.goodListSelect = true;
            this.listTableData = this.$refs['listOperation'].getTabelData()// table数据
            // this.$nextTick(() => {
            //   this.$refs['goodsListOperation'].getTableData(this.otherParam);
            // });
          }
        }
      },
      // 商品多选，确认事件
      rowsSelectSubmit(rows) {
        this.listShow = false;
        rows.map(item => {
          item.subtotalAmount = 0.00.toFixed(2);
          item.blitemNum = 0.000.toFixed(3);
        });
        let tableList = this.$refs['listOperation'].getTabelData();
        this.$refs['listOperation'].addMoreRow(rows, tableList.length);
        this.currentTableList = this.$refs['listOperation'].getTabelData();
        if (rows && rows.length > 0) {
          this.$message.success("商品添加成功");
        }
      },

      // 审核按钮事件
      examineAndVerify() {
        if (!this.isCheck) {
          this.$confirm('是否审核数据，请确认?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              let tableList = this.$refs['listOperation'].getTabelData();
              let orderNumber = 1;
              tableList.map(item => {
                item.orderNumber = orderNumber++;
                item.goodsNum = item.blitemNum;
                item.goodsBarCode = item.barCode;
              });
              let totalParam = this.$refs['listOperation'].getSumData();
              totalParam.billAmount = totalParam.subtotalAmount;
              let headParam = this.$refs.listOperationForm.getFormModel();
              if (headParam.requireStoreId === headParam.deliverStoreId) {
                this.$message.warning("发货门店和要货门店不能相同");
                return;
              }
              let searchParam = {
                ...{goodsMapMVOList: tableList}, ...totalParam, ...headParam
              };
              console.log(searchParam);
              searchParam.operateFlag = 'examine';
              this.$axios.fetchPost('/api/eros/dn/dnRequireOrder/updaterequireorder', searchParam).then(data => {
                this.loading = false;
                if (data.code === 200) {
                  this.$notify({
                    type: "success",
                    title: '审核操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message({message: '审核成功!', type: 'success'});
                  this.dialogShow = false;
                  this.$router.push({path: '/delivery/requisition'});
                } else {
                  if (data.errorMsg) {
                    this.$message({message: data.errorMsg, type: 'error'});
                  } else {
                    this.$message({message: data.msg, type: 'error'});
                  }
                }
              })
                .catch(err => {
                  this.$message({message: '审核失败！', type: 'error'});
                  this.loading = false;
                });
            })
            .catch(() => {
              // this.$message({type: 'info', message: '已取消删除'});
            });
        }
      },

      selectLevel(data) {
        // 如果调拨级别是门店显示门店选择
        if (data.relateType === 20) {
          this.listFormOptions.columns.filter(item => item.prop === 'deliverStoreId')[0].hidden = false
        } else {
          this.listFormOptions.columns.filter(item => item.prop === 'deliverStoreId')[0].hidden = true;
          this.$refs.listOperationForm.formModel.deliverStoreId = '';
        }
      },
      getWarehouse(row) {
        if (row.deliverStoreId === row.requireStoreId) {
          this.$message({message: '要货门店和发货门店不能相同!', type: 'warning'});
          this.$refs.listOperationForm.formModel.deliverStoreId = '';
        } else {
          this.isSelectStore = false;
        }
      },
      storeChange(row) {
        if (row.deliverStoreId === row.requireStoreId) {
          this.$message({message: '要货门店和发货门店不能相同!', type: 'warning'});
          this.$refs.listOperationForm.formModel.deliverStoreId = '';
          this.isSelectDeliverStoreId = true;
        } else {
          let storeId = row.deliverStoreId;
          this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {
            storeId: storeId
          }).then(data => {
            if (data.code === 200) {
              data.data.map(item => {
                if (item.defaultState) {
                  this.otherParam.warehouseId = item.id;
                  this.otherParam.storeId = storeId;
                }
              })
            }
          });
          this.isSelectDeliverStoreId = false;
          if (!this.$route.query.id) {
            this.$refs['listOperation'].clearTableData();
          }
          this.otherParam.storeId = row.deliverStoreId;
        }
      },
      downloadTemplate() {
        if (!this.isCheck) {
          this.$axios.fetchPost(api.delivery.requireDownloadTemplate).then(data => {
            if (data.code === 200) {
              const elink = document.createElement('a');
              elink.href = data.data;
              elink.click();
              this.loadingExt = false;
              this.$notify({
                type: "success",
                title: '导出操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '导出成功', type: 'success'});
            } else {
              this.$notify({
                type: "error",
                title: '导出操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '导出异常', type: 'error'});
            }
          })
        }
      },
      // 导入
      importData() {
        if (!this.isCheck) {
          let tableData = this.$refs.listOperationForm.formModel;
          if (tableData.requireStoreId) {
            if (tableData.deliverStoreId) {
              this.$utils.uploadFile((file) => {
                this.loading = true;
                let formData = new FormData();
                formData.append('multipartFile', file);
                formData.append('storeId', this.otherParam.storeId);
                formData.append('warehouseId', this.otherParam.warehouseId);
                this.$refs['listOperation'].clearTableData();
                const loading = this.$loading({
                  lock: true,
                  text: '提交中，请稍候...',
                  background: 'rgba(225, 225, 225, 0.8)'
                });
                this.$axios
                  .fetchPostGoodsExport(api.delivery.importGoods, formData)
                  .then(data => {
                    if (data.code === 200) {
                      this.importShow = false;
                      // 为表格赋值
                      if (data.data.weWarehouseGoodsMapMVOList) {
                        data.data.weWarehouseGoodsMapMVOList.map(item => {
                          item.id = item.goodsId;
                          item.subtotalAmount = (item.blitemNum * item.purchasePrice).toFixed(2);
                        });
                        this.$refs['listOperation'].addMoreRow(data.data.weWarehouseGoodsMapMVOList, 0);
                      }
                      if (data.data.errorBatchId) {
                        this.exportErrorData(data.data.errorBatchId);
                      }
                    } else {
                      if (data.errorMsg) {
                        this.$message({message: data.errorMsg, type: 'error'});
                      } else {
                        this.$message({message: '导入异常', type: 'error'});
                      }
                    }
                  })
                  .catch((err) => {
                    this.loading = false;
                    console.log(err);
                  }).finally(() => {
                  loading.close()
                })
              });
            } else {
              this.$message({message: '请选择发货门店！', type: 'warning'});
            }
          } else {
            this.$message({message: '请选择要货门店！', type: 'warning'});
          }
        }
      },
      // 导入的错误数据
      exportErrorData(id) {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        this.$axios.PostBlob(api.system.exportError + '?batchId=' + id, '').then(res => {
          if (res.status === 200) {
            const fileName = '要货单错误数据' + '_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            // this.$message.success("导出成功,文件名称:" + fileName);
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },
      openImport() {
        if (!this.isCheck) {
          let tableData = this.$refs.listOperationForm.formModel;
          if (tableData.requireStoreId) {
            if (tableData.deliverStoreId) {
              let data = this.$refs.listOperationForm.formModel;
              if (data.requireStoreId === data.deliverStoreId) {
                this.$message.warning("发货门店和要货门店不能相同");
                return;
              }
              this.importShow = true;
            } else {
              this.$message.warning("请选择发货门店")
            }
          } else {
            this.$message.warning("请选择要货门店")
          }
        }
      },
    }
  }
</script>

<style scoped>
  >>> .el-dialog__header {
    margin-bottom: 5px;
  }

  .deliver-add .el-select, .deliver-add .el-input {
    width: 300px;
  }

  .order-add-page .search-goods-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .order-add-page .search-goods-box .select-good {
    margin-left: 16px;
  }

  .search-goods-input {
    width: 300px;
  }

  /deep/ #goodsText {
    height: 32px;
  }

  /deep/ .importDialog {
    width: 640px;
    min-width: 640px;
  }
</style>



// WEBPACK FOOTER //
// src/page/delivery/RequistionAdd.vue